import { Header } from '../components/layout/Header'
import { Footer } from '../components/layout/Footer'

export function SupportPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header variant="light" />
      <div className="container mx-auto px-4 py-12 flex-1">
        <article className="prose mx-auto max-w-2xl">
          <h1 className="text-4xl font-bold text-[var(--color-text-primary)] mb-4">
            Support
          </h1>
          <p className="text-lg text-[var(--color-text-primary)] mb-8">
            Need help with Shoots? We're here.
          </p>

          <h2 className="text-2xl font-semibold text-[var(--color-text-primary)] mt-10 mb-3">
            Contact us
          </h2>
          <p className="text-[var(--color-text-primary)] mb-2">
            Email:{' '}
            <a
              href="mailto:contact@getshoots.app"
              className="font-semibold text-[var(--color-action-primary)] hover:underline"
            >
              contact@getshoots.app
            </a>
          </p>
          <p className="text-[var(--color-text-secondary)]">
            We typically reply within one business day.
          </p>

          <h2 className="text-2xl font-semibold text-[var(--color-text-primary)] mt-10 mb-3">
            What to include
          </h2>
          <p className="text-[var(--color-text-primary)] mb-3">
            When you reach out, please tell us:
          </p>
          <ul className="list-disc pl-6 space-y-1 text-[var(--color-text-primary)]">
            <li>A brief description of what's happening</li>
            <li>
              The event or invite link if it's related to a specific gathering
            </li>
            <li>
              Your device (iOS app or web) and the approximate time the issue
              happened
            </li>
          </ul>
          <p className="text-[var(--color-text-secondary)] mt-3">
            This lets us track down the problem faster.
          </p>

          <h2 className="text-2xl font-semibold text-[var(--color-text-primary)] mt-10 mb-3">
            Common questions
          </h2>

          <h3 className="text-lg font-semibold text-[var(--color-text-primary)] mt-6 mb-2">
            I paid for an event — when does the host get the money?
          </h3>
          <p className="text-[var(--color-text-primary)]">
            Payments are processed by Stripe and transferred to the event host
            on Stripe's standard payout schedule (typically within a few
            business days).
          </p>

          <h3 className="text-lg font-semibold text-[var(--color-text-primary)] mt-6 mb-2">
            I need a refund.
          </h3>
          <p className="text-[var(--color-text-primary)]">
            Refund policies are set by the event host. Reach out to the host
            first; if you can't get a response, email us.
          </p>

          <h3 className="text-lg font-semibold text-[var(--color-text-primary)] mt-6 mb-2">
            I'm an event host and want to accept payments.
          </h3>
          <p className="text-[var(--color-text-primary)]">
            Open Shoots, create an event with a price, and tap "Set up payments"
            to onboard with our payments partner (Stripe). You'll need a real
            bank account and a few minutes to complete identity verification.
          </p>

          <h3 className="text-lg font-semibold text-[var(--color-text-primary)] mt-6 mb-2">
            Something else?
          </h3>
          <p className="text-[var(--color-text-primary)]">
            Email{' '}
            <a
              href="mailto:contact@getshoots.app"
              className="font-semibold text-[var(--color-action-primary)] hover:underline"
            >
              contact@getshoots.app
            </a>{' '}
            and we'll help.
          </p>
        </article>
      </div>
      <Footer />
    </div>
  )
}
